import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Collapse} from 'react-collapse';
import Card from 'common/card/Card';

export default class CheckoutPanel extends Component {
    static propTypes = {
        className: PropTypes.string,
        open: PropTypes.bool,
        closeable: PropTypes.bool,
        onOpen: PropTypes.func,
        title: PropTypes.node,
        additionalTitleMarkup: PropTypes.node,
        children: PropTypes.node,
        preview: PropTypes.node
    };
    static defaultProps = {
        open: true,
        closeable: true
    };
    state = {
        open: this.props.open,
        heightReady: false
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            open
        } = nextProps;

        if (open !== prevState.open) {
            return {
                open
            };
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            onOpen
        } = this.props;
        const {
            open
        } = this.state;

        if (onOpen && open && !prevState.open) {
            onOpen();
        }
    }

    _onMeasure = () => {
        this.setState({
            heightReady: true
        });
    }

    render() {
        const {
            className,
            closeable,
            title,
            additionalTitleMarkup,
            children,
            preview
        } = this.props;
        const {
            open,
            heightReady
        } = this.state;
        const containerClasses = classNames(
            'CheckoutPanel',
            {'CheckoutPanel-open': open},
            {'CheckoutPanel-no-close': !closeable},
            {'CheckoutPanel-no-preview': !preview},
            className
        );
        const contentClasses = classNames(
            'CheckoutPanel-content',
            {'CheckoutPanel-content-hidden': !heightReady}
        );

        return (
            <Card
                className={containerClasses}
                title={
                    <div className="CheckoutPanel-heading">
                        <h2 className="CheckoutPanel-title">
                            {title}
                        </h2>
                        {additionalTitleMarkup}
                    </div>
                }
            >
                {preview && <div className="CheckoutPanel-preview">{preview}</div>}
                <Collapse
                    isOpened={open}
                    onMeasure={this._onMeasure}
                    springConfig={{stiffness: 300, damping: 25}}
                >
                    <div className={contentClasses}>
                        {children}
                    </div>
                </Collapse>
            </Card>
        );
    }
}
